<template>
  <div>
    <div>
      <!-- <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Search by title" v-model="title" />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click="searchTitle">
              Search
            </button>
          </div>
        </div> -->

      <div class="form-group">
        <label for="exampleFormControlSelect1"
          ><h5 style="width: 200px">
            <i class="bi bi-person-plus"></i> 셀 보고서 등록
          </h5></label
        >
        <!-- <span
            ><button
              type="button"
              class="btn btn-primary btn-sm"
              @click="AddMember"
            >
              신규
            </button>
          </span> -->
        <!-- @change="onChange(this)" -->
        <select
          class="form-control"
          id="holiday"
          name="holiday"
          v-model="holiday"
          @change="getStudentList()"
        >
          <option id="" value="00">날짜를 선택하세요.</option>
          <option
            v-for="daylist in dayLists"
            :key="daylist.dday"
            v-bind:value="daylist.dday"
            :id="daylist.dday"
            :selected="daylist.dday == daylist.cday"
          >
            {{ daylist.dday }}
          </option>
        </select>
      </div>
    </div>

    <div>
      <select
        class="form-control"
        id="gradegroup"
        name="gradegroup"
        v-model="gradegroup"
        @change="getGradeGroup()"
        v-show="this.role > 4"
      >
        <option id="" value="00">조회 대상을 선택하세요.</option>
        <option
          v-for="gradelist in gradegrouplist"
          :key="gradelist.grade"
          v-bind:value="gradelist.grade"
          :id="gradelist.grade"
        >
          {{ gradelist.gradename }}
        </option>
      </select>
    </div>
    <p></p>

    <div class="form-group">
      <label style="color: blue">셀 모임 진행 및 특이사항</label>
      <textarea
        class="form-control"
        rows="7"
        v-model="groupReport"
        placeholder="진행방식, 분위기, 반응, 간증이나, 공유사항, 차후 계획등 자세한 내용으로 입력해 주세요."
        style="width: 90%;"
        :readonly="!isLeader"
      ></textarea>
      <div v-if="isLeader" style="text-align: right; margin-top: 6px; width: 90%;">
        <button type="button" class="btn btn-info btn-sm" @click="loadLastGroupReport" style="margin-right: 4px; font-size: 0.6rem; padding: .15rem .3rem; line-height: 1.2;">
          불러오기
        </button>
        <button type="button" class="btn btn-primary btn-sm" @click="submitGroupReport" style="font-size: 0.6rem; padding: .15rem .3rem; line-height: 1.2;">
          등록
        </button>
      </div>
    </div>

    <div>
      <ul class="list-group" v-if="memberLists.length > 0">
        <li
          class="list-group-item justify-content-between align-items-center"
          v-for="memberList in memberLists"
          :key="memberList.no"
          style="padding-left: 0.5rem; padding-right: 0.1rem"
        >
          <div class="row">
            <div class="col-5">
              <b>
                <div class="row">
                  <div class="col-sm-5">
                    <div
                      v-if="memberList.photo && memberList.photo.length > 0"
                      class="form-group mb-2"
                    >
                      <img
                        :src="photourl(memberList.photo)"
                        alt="..."
                        class="img-thumbnail"
                        style="width: 50%"
                      />
                    </div>                
                    <div
                      v-else
                      class="form-group mx-sm-3 mb-2"
                      style="text-align: left"
                    >
                      <img src="../assets/noimage.png" style="width: 40%" />
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <span class="align-middle"
                      >{{ memberList.name }}({{ getLastFourDigits(memberList.phone) }})</span
                    >
                  </div>
                </div>
              </b>
            </div>
            <div class="col-7">
              <div style="text-align: right; margin-bottom: 6px;">
                <span style="padding-left: 0px" v-if="memberList.attendyn == 'Y'">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="attendcheck(memberList, '1')"
                  >
                    예배
                  </button>
                </span>
                <span style="padding-left: 0px" v-else>
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="attendcheck(memberList, '1')"
                  >
                  예배
                  </button>
                </span>
                <span style="padding-left: 2px" v-if="memberList.cellattendyn == 'Y'">
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    @click="attendcheck(memberList, '2')"
                  >
                    셀모임
                  </button>
                </span>
                <span style="padding-left: 2px" v-else>
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="attendcheck(memberList, '2')"
                  >
                  셀모임
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 8px;">
            <div class="col-12">
              <textarea
                class="form-control"
                rows="7"
                v-model="memberList._inlinePray"
                placeholder="근황이나 기도 제목 등 자유롭게 나눠주세요."
                style="width: 90%;"
              ></textarea>
              <div style="text-align: right; margin-top: 6px; width: 90%;">
                <button type="button" class="btn btn-info btn-sm" @click="loadLastReportInline(memberList)" style="margin-right: 4px; font-size: 0.6rem; padding: .15rem .3rem; line-height: 1.2;">
                  불러오기
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click="submitMemberReport(memberList)" style="font-size: 0.6rem; padding: .15rem .3rem; line-height: 1.2;">
                  등록
                </button>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <ul class="list-group" v-else>
        <div class="row" style="width: 100%; text-align: center">
          <div class="col-12">조회된 자료가 없습니다.</div>
        </div>
      </ul>
      <!-- <button class="m-3 btn btn-sm btn-danger" @click="removeAllTutorials">
            Remove All
          </button> -->
    </div>

    <div
      class="modal fade"
      id="reportModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="reportModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="reportModalLabel" style="color: blue">
              <span id="plpmo"></span>
              <div>보고서</div>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <form
                id="addReportForm"
                name="addReportForm"
                v-on:submit="addReportForm"
              >
                <div class="form-group mx-sm-3 mb-2"></div>
                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >{{ form.name }}({{ form.sex }})</label
                  >
                  <textarea
                    class="form-control"
                    id="pl"
                    name="pray"
                    rows="7"
                    v-model="form.pray"
                    required
                    placeholder="근황이나 기도 제목 등 자유롭게 나눠주세요."
                  ></textarea>
                  <div  v-if="form.grade == '2' || form.grade == '3'" style="padding-top: 13px;color:blue"> 셀 모임 진행 및 특이사항 </div>
                  <textarea
                    v-if="form.grade == '2' || form.grade == '3' "
                    class="form-control"
                    id="pl"
                    name="report"
                    rows="7"
                    v-model="form.report"
                    placeholder="진행방식, 분위기, 반응, 간증이나, 공유사항, 차후 계획등 자세한 내용으로 입력해 주세요."
                  ></textarea>

                  <input type="hidden" name="no" v-model="form.no" />
                  <input
                    type="hidden"
                    name="studentid"
                    v-model="form.studentid"
                  />
                  <input
                    type="hidden"
                    name="teacherid"
                    v-model="form.teacherid"
                  />
                  <input type="hidden" name="attenddate" v-model="holiday" />
                  <input type="hidden" name="classid" v-model="form.classid" />
                  <input type="hidden" name="groupid" v-model="form.groupid" />
                  <input type="hidden" name="grade" v-model="form.grade" />
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-info" @click="loadLastReport">
                    불러오기
                  </button>
                  <button type="submit" class="btn btn-primary" v-if="isNew">
                    등록
                  </button>
                  <button type="submit" class="btn btn-primary" v-else>
                    수정
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <div class="text-right" style="font-size: smaller;">
                    "불러오기"는 이전 주에 등록된 보고서만 가져옵니다.
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import manageService from "../services/manageService";

  import $ from "jquery";

  export default {
    name: "list",
    component: {},
    data() {
      return {
        dayLists: {},
        pageTotalCount: 0,
        page: 15,
        holiday: "00",
        currentDept: "",
        memberLists: {},
        id: this.$store.state.id,
        grade: this.$store.state.grade,
        phone: this.$store.state.phone,
        name: this.$store.state.name,
        teacherid: this.$store.state.teacherid,
        role: this.$store.state.role,
        token: this.$store.state.token,
        classid: this.$store.state.classid,
        studentid: this.$store.state.studentid,
        groupReport: "",
        form: {
          studentid: "",
          teacherid: "",
          no: "",
          attenddate: "",
          pray: "",
          name: "",
          sex: "",
          classid: "",
          groupid: "",
          grade: "",
          report: "",
        },
        isNew: false,
        firstselect: "selected",
        gradegrouplist: {},
        gradegroup: "00",
      };
    },
    computed: {
      photourl() {
        return (url) => {
          return "./upload/photo/" + url;
        };
      },
      isLeader() {
        // 셀리더: 로그인한 studentid 와 teacherid 가 동일
        return String(this.studentid) === String(this.teacherid);
      },
    },
    methods: {
      sanitizeText(text) {
        return (text || '').replace(/'/g, '');
      },
      //전화번호 뒤4자리만
      getLastFourDigits(tel) {
        return tel ? tel.slice(-4) : '';
      },       
      getGradeGroup() {
        if (this.holiday === "00") {
          this.$toast.show("날짜를 먼저 선택해주세요.", {
            type: "warning",
            position: "top-right",
          });
          //this.gradegroup = "00";
          //return;
        }

        const data = {
          attenddate: this.holiday,
          grade: this.gradegroup,
          teacherid: this.form.teacherid,
          role: this.role,
          classid: this.classid,
        };

        manageService
          .getAttendanceList(data)
          .then((response) => {
            // 각 멤버에 인라인 입력용 필드 초기화
            this.memberLists = (response.data || []).map((m) => ({
              ...m,
              _inlinePray: m.pray || "",
            }));
            this.updateGroupReportFromMemberList();
          })
          .catch((e) => {
            console.log(e);
          });
      },
      getGradeGroupList() {
        const ndata = {
          classid: this.classid,
          grade: this.gradegroup,
          role: this.role,
        };

        // 학년 반을 선택하세요.
        manageService
          .getGradeListAll(ndata)
          .then((response) => {
            //this.manageLists = response.data;
            this.gradegrouplist = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
      },
      //개행문자 인식
      getHtmlConvert(str) {
        const replacer = new RegExp("\\n", "g");
        return str.replace(replacer, "<br />");
      },
      getDayList() {
        manageService
          .getDaysList()
          .then((response) => {
            this.dayLists = response.data.slice(0, this.page);
            //console.log('this.dayLists', this.dayLists);
          })
          .catch((e) => {
            console.log(e);
          });
      },
      //전체 리스트 가져오기
      getStudentList() {
        //if( this.gradegroup === "00") return;

        const data = {
          attenddate: this.holiday,
          grade: this.grade,
          teacherid: this.studentid,          
          role: this.role,
          classid: this.classid,
        };
       
        manageService
          .getAttendanceList(data)
          .then((response) => {
            // 각 멤버에 인라인 입력용 필드 초기화
            this.memberLists = (response.data || []).map((m) => ({
              ...m,
              _inlinePray: m.pray || "",
            }));
            this.updateGroupReportFromMemberList();
          })
          .catch((e) => {
            console.log(e);
          });

      },

      attendcheck(item, sector) {
        //출석체크
        var checkyn = "";
        if(sector == "1"){  // 마을
          if (item.attendyn == "Y") {
            checkyn = "N";
          } else {
            checkyn = "Y";
          }
        } else {           //반출석
          if (item.cellattendyn == "Y") {
            checkyn = "N";
          } else {
            checkyn = "Y";
          }          
        }


        const data = {
          classid: item.classid,
          studentid: item.studentid,
          grade: item.grade,
          sector: sector,
          holiday: this.holiday,
          teacherid: item.teacherid,
          groupid: item.groupid,
          checkyn: checkyn,          
        };

        manageService
          .setAttendChech(data)
          .then(() => {
            this.$toast.show("출결이 처리되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList();
          })
          .catch((e) => {
            console.log(e);
          });
      },

      reporting(item) {
        //리포트 보고서

        this.isNew = true;
        this.form.studentid = item.studentid;
        this.form.teacherid = item.teacherid;
        this.form.no = item.no;
        this.form.attenddate = item.attenddate;
        this.form.pray = item.pray;
        this.form.name = item.name;
        this.form.sex = item.sex;
        this.form.classid = item.classid;
        this.form.groupid = item.groupid;
        this.form.grade = item.grade;
        this.form.report = item.report;
        //console.log(this.form);
        $("#reportModal").modal("show");
      },

      addReportForm(e) {
        e.preventDefault();
        var object = {};
        var fform = document.getElementById("addReportForm");
        var form = new FormData(fform);
        form.forEach(function (value, key) {
          object[key] = value;
        });

        // sanitize single quotes before submit
        object.pray = this.sanitizeText(object.pray);
        object.report = this.sanitizeText(object.report);

        var jsondata = JSON.stringify(object);

        // const data = {
        //   classid: JSON.parse(jsondata).classid,
        //   studentid: JSON.parse(jsondata).studentid,
        //   grade: JSON.parse(jsondata).grade,
        //   sector: "1",
        //   holiday: this.holiday,
        //   teacherid: JSON.parse(jsondata).teacherid,
        //   groupid: JSON.parse(jsondata).groupid,
        //   checkyn: "",
        // };

        if (JSON.parse(jsondata).pray.length < 2) {
          this.$toast.show("내용을 입력해주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        //신규 모드
        manageService
          .reportWrite(jsondata)
          .then(() => {
            this.$toast.show("보고서가 등록되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList();
            $("#reportModal").modal("hide");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서가 등록되지 않았습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },

      loadLastReport() {
        const data = {
          classid: this.form.classid,
          studentid: this.form.studentid
        };

        manageService
          .getLastReport(data)
          .then((response) => {           
            if (response.data) {           
              this.form.pray = "[이전 보고서]"+response.data[0];      
              this.$toast.show("보고서를 불러왔습니다.", {
                type: "success",
                position: "top-right",
              });                      
            } else {
              this.$toast.show("이전 주에 등록된 보고서가 없습니다.", {
                type: "warning",
                position: "top-right",
              });
            }
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서를 불러오는데 실패했습니다.", {
              type: "error",
              position: "top-right",
            });
          });
      },

      loadLastReportInline(member) {
        const data = {
          classid: member.classid,
          studentid: member.studentid,
        };

        manageService
          .getLastReport(data)
          .then((response) => {
            if (response.data) {
              // weekly_before.php 는 첫 컬럼을 0 인덱스로도 반환
              member._inlinePray = "[이전 보고서]" + response.data[0];
              this.$toast.show("보고서를 불러왔습니다.", {
                type: "success",
                position: "top-right",
              });
            } else {
              this.$toast.show("이전 주에 등록된 보고서가 없습니다.", {
                type: "warning",
                position: "top-right",
              });
            }
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서를 불러오는데 실패했습니다.", {
              type: "error",
              position: "top-right",
            });
          });
      },

      submitMemberReport(member) {
        if (!member._inlinePray || member._inlinePray.length < 2) {
          this.$toast.show("내용을 입력해주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }

        const cleanedPray = this.sanitizeText(member._inlinePray);
        const cleanedReport = this.sanitizeText(this.groupReport || "");
        // reflect sanitized values in UI
        member._inlinePray = cleanedPray;
        this.groupReport = cleanedReport;

        const payload = {
          no: member.no,
          studentid: member.studentid,
          teacherid: member.teacherid,
          attenddate: this.holiday,
          pray: cleanedPray,
          classid: member.classid,
          groupid: member.groupid,
          grade: member.grade,
          // 상단 공통 보고서를 함께 저장 (백엔드 변경 없음)
          report: cleanedReport,
        };

        const jsondata = JSON.stringify(payload);

        manageService
          .reportWrite(jsondata)
          .then(() => {
            this.$toast.show("보고서가 등록되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList();
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서가 등록되지 않았습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },

      loadLastGroupReport() {
        if (!this.memberLists || this.memberLists.length === 0) {
          this.$toast.show("먼저 날짜와 대상을 선택해 주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }

        const base = this.memberLists[0];
        const data = {
          classid: base.classid,
          studentid: base.studentid,
        };

        manageService
          .getLastReport(data)
          .then((response) => {
            if (response.data) {
              this.groupReport = "[이전 보고서]" + response.data[0];
              this.$toast.show("보고서를 불러왔습니다.", {
                type: "success",
                position: "top-right",
              });
            } else {
              this.$toast.show("이전 주에 등록된 보고서가 없습니다.", {
                type: "warning",
                position: "top-right",
              });
            }
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서를 불러오는데 실패했습니다.", {
              type: "error",
              position: "top-right",
            });
          });
      },

      submitGroupReport() {
        if (!this.isLeader) {
          this.$toast.show("셀 리더만 등록할 수 있습니다.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        if (!this.groupReport || this.groupReport.trim().length < 2) {
          this.$toast.show("내용을 입력해주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }

        if (!this.memberLists || this.memberLists.length === 0) {
          this.$toast.show("먼저 날짜와 대상을 선택해 주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }

        // 대표 멤버(첫 번째) 기준으로 그룹 보고서만 저장
        const target = this.memberLists[0];
        const cleanedReport = this.sanitizeText(this.groupReport);
        this.groupReport = cleanedReport;
        const payload = {
          no: target.no,
          studentid: target.studentid,
          teacherid: target.teacherid,
          attenddate: this.holiday,
          pray: target._inlinePray || target.pray || "",
          classid: target.classid,
          groupid: target.groupid,
          grade: target.grade,
          report: cleanedReport,
        };

        const jsondata = JSON.stringify(payload);

        manageService
          .reportWrite(jsondata)
          .then(() => {
            this.$toast.show("보고서가 등록되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList();
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서가 등록되지 않았습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },

      updateGroupReportFromMemberList() {
        if (!Array.isArray(this.memberLists) || this.memberLists.length === 0) {
          this.groupReport = "";
          return;
        }
        // 첫 번째 멤버의 report 값을 대표로 사용 (없으면 비움)
        const first = this.memberLists[0];
        this.groupReport = first && first.report ? first.report : "";
      },
    },
    created() {
      this.getDayList();
      
      if(this.role > 3){
        this.getStudentList(); //초기 전체 리스트
        this.getGradeGroupList();
      }
    },
  };
</script>

<style>
  .list {
    text-align: left;
    max-width: 750px;
    margin: auto;
  }
  .done {
    background: oldlace;
  }
</style>
